import React, { FC } from 'react'

import { EuiPanel, EuiTitle, EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiButtonIcon } from '@elastic/eui'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'

import ConnectedTvNetworks from './ConnectedTvNetworks'
import TopInternetDisplaySites from './TopInternetDisplaySites'

export interface PlacementChartsProps {
  masterCampaignPlan: any
  hasInternet: boolean
  hasTv: boolean
  whereAdsAppearTitle: string
  auctionBasedPlacementsSection?: MasterCampaignPlanCustomSection
  ctvSection?: MasterCampaignPlanCustomSection
  internetSection?: MasterCampaignPlanCustomSection
  editMode?: boolean
  onEditWhereAdsAppearTitle?: () => void
  onEditAuctionBasedPlacements?: () => void
  onEditCtvPlacementCategories?: () => void
  onEditInternetAdPlacements?: () => void
}

const PlacementCharts: FC<PlacementChartsProps> = ({ masterCampaignPlan, hasInternet, hasTv, whereAdsAppearTitle, auctionBasedPlacementsSection, ctvSection, internetSection, editMode, onEditWhereAdsAppearTitle, onEditAuctionBasedPlacements, onEditCtvPlacementCategories, onEditInternetAdPlacements }) => {
  if (auctionBasedPlacementsSection?.hideAll === true) {
    return null
  }

  const auctionTitle = auctionBasedPlacementsSection?.title ?? 'Auction-Based Placements'
  const auctionContent = auctionBasedPlacementsSection?.content ?? 'Ad placements are made via auction-based ad exchanges. Bidding is optimized to prioritize audience and geographic accuracy over publisher allocation, so some variation in final distribution may occur.'
  const auctionShowTitle = auctionBasedPlacementsSection?.showTitle ?? true

  const width = hasInternet && hasTv ? '45%' : '90%'

  return (
    <>
      <EuiPanel paddingSize='l'>
        <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
          <EuiFlexItem grow={false}>
            <EuiTitle size='m'>
              <h2>{whereAdsAppearTitle}</h2>
            </EuiTitle>
          </EuiFlexItem>
          {editMode && onEditWhereAdsAppearTitle && (
            <EuiFlexItem grow={false}>
              <EuiButtonIcon iconType='pencil' onClick={onEditWhereAdsAppearTitle} aria-label='Edit title' />
            </EuiFlexItem>
          )}
        </EuiFlexGroup>

        <EuiSpacer size='l' />

        <div style={{ marginLeft: '2rem' }}>
          <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
            <EuiFlexItem grow={false}>
              {auctionShowTitle && (
                <EuiTitle size='xs'>
                  <h3>{auctionTitle}</h3>
                </EuiTitle>
              )}
            </EuiFlexItem>
            {editMode && onEditAuctionBasedPlacements && (
              <EuiFlexItem grow={false}>
                <EuiButtonIcon iconType='pencil' onClick={onEditAuctionBasedPlacements} aria-label='Edit' />
              </EuiFlexItem>
            )}
          </EuiFlexGroup>

          <EuiSpacer size='s' />

          <EuiText size='m' style={{ whiteSpace: 'pre-wrap' }}>
            {auctionContent}
          </EuiText>
        </div>

        <EuiSpacer size='l' />

        <EuiFlexGroup gutterSize='xl'>
          {hasTv && (
            <EuiFlexItem style={{ width: width }}>
              <ConnectedTvNetworks masterCampaignPlan={masterCampaignPlan} section={ctvSection} editMode={editMode} onEdit={onEditCtvPlacementCategories} />
            </EuiFlexItem>
          )}

          {hasInternet && (
            <EuiFlexItem style={{ width: width }}>
              <TopInternetDisplaySites masterCampaignPlan={masterCampaignPlan} section={internetSection} editMode={editMode} onEdit={onEditInternetAdPlacements} />
            </EuiFlexItem>
          )}
        </EuiFlexGroup>
      </EuiPanel>
    </>
  )
}

export default PlacementCharts
